

<template>
  <meta content="yes" name="apple-mobile-web-app-capable" />
  <meta
    name="viewport"
    content="width=device-width,height=device-height,inital-scale=1.0,maximum-scale=1.0,user-scalable=no;"
  />
  <Nav-bar :has_back="true" :has_right="false" title="余额充值"></Nav-bar>
  <div class="container">
    <img src="@/images/recharge_bg.png" class="bg" />
    <!-- <div class="notive-view">
      <van-notice-bar
        left-icon="volume-o"
        text="双11余额充值活动：充100元，赠送10元。双12余额充 20 送10元"
      />
    </div> -->

    <div class="grid-container">
      <div class="bg-v">
        <div class="m-t-10">
          <span class="t-f14-c1a font-bold">选择充值金额</span>
          <span class="t-f13-c66">（本次最多充值金额 5000 元）</span>
        </div>
        <div class="line" />
        <van-grid :gutter="10" column-num="3">
          <van-grid-item>
            <span
              class="grid-item-v t-f18-c1a font-bold"
              :class="indexCode == 30 && 'selected'"
              @click="cutIndex(30)"
              >30元</span
            >
          </van-grid-item>

          <van-grid-item>
            <span
              class="grid-item-v t-f18-c1a font-bold"
              :class="indexCode == 50 && 'selected'"
              @click="cutIndex(50)"
              >50元</span
            >
          </van-grid-item>
          <van-grid-item>
            <span
              class="grid-item-v t-f18-c1a font-bold"
              :class="indexCode == 100 && 'selected'"
              @click="cutIndex(100)"
              >100元</span
            >
          </van-grid-item>
          <van-grid-item>
            <span
              class="grid-item-v t-f18-c1a font-bold"
              :class="indexCode == 200 && 'selected'"
              @click="cutIndex(200)"
              >200元</span
            >
          </van-grid-item>
          <van-grid-item>
            <span
              class="grid-item-v t-f18-c1a font-bold"
              :class="indexCode == 300 && 'selected'"
              @click="cutIndex(300)"
              >300元</span
            >
          </van-grid-item>
          <van-grid-item>
            <div
              class="grid-item-v"
              :class="indexCode == 0 && 'selected'"
              @click="cutIndex(0)"
            >
              <van-field
                class="input-sytle"
                v-model="chargeValue"
                placeholder="输入金额"
                maxlength="5"
                type="number"
              />
            </div>
          </van-grid-item>
        </van-grid>
      </div>
      <div class="bg-v m-t-10">
        <div class="m-t-5">
          <span class="t-f14-c1a font-bold">选择支付方式</span>
          <div class="line" />
          <div class="pay-type">
            <img src="../../images/payment_wechat.png" class="wechat" />
            <span class="wechat-font">微信钱包</span>
            <img src="../../images/wechat_choose.png" class="wechat_c" />
          </div>
        </div>
      </div>
      <div class="m-20">
        <van-button
          type="primary"
          size="normal"
          class="main-btn"
          @click="toWxPay"
          >充值</van-button
        >
      </div>
    </div>
    <van-popup v-model:show="show">
      <div class="reject-view">
        <div class="">
          <img src="../../images/recharge_success.png" class="icon" />
          <span class="t-f16-c1a font-bold m-l-5 center">充值成功</span>
        </div>
        <div class=" m-t-10">
          <span class="t-f14-c78">本次充值金额</span>
          <span class="m-l-10 t-f16-c0082ff">{{price}}元</span>
        </div>
        <div class="m-t-20">
        <van-button
          type="primary"
          size="normal"
          class="main-btn"
          @click="commit()"
          >确定</van-button
        >
      </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import { useRouter } from "vue-router";
import { ref } from "vue";
import wx from "weixin-js-sdk";
import request from "@/api/request";
import { Toast } from "vant";
let router;
let chargeValue;
let indexCode;
let data;
let show
let price = ref(50)
export default {
  components: {
    NavBar,
  },
  setup() {
    show= ref(false);
    router = useRouter();
    chargeValue = ref("");
    indexCode = ref(50);
    const showPopup = () => {
      show.value = true;
    };
    const commit = ()=>{
       router.back();
    }
    setWxConfig();
    return { chargeValue, commit,show, price,indexCode, cutIndex, showPopup, toWxPay };
  },
};
function toWxPay() {
  let priceNumber = 50;
  if (indexCode.value != 0) {
    priceNumber = indexCode.value;
  }
  if (indexCode.value == 0) {
    priceNumber = chargeValue.value;
  }

  // if (priceNumber < 5) {
  //   Toast("单次充值最低为5元");
  //   return;
  // }
  if (priceNumber > 5000) {
    Toast("单次充值最高为5000元");
    return;
  }
  price.value = priceNumber
  request
    .directWxPay({
      price: priceNumber * 100,
      // service_provider_id: "5c681155-7b57-4428-af18-09287d9d10a3"
    })
    .then((res) => {
      let payData = res.data.body;
      wx.chooseWXPay({
        timestamp: payData.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
        nonceStr: payData.nonceStr, // 支付签名随机串，不长于 32 位
        package: payData.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
        signType: payData.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
        paySign: payData.paySign, // 支付签名
        success: function () {
          // 支付成功后的回调函数
          request
            .postWebCheckPayOrders({ out_trade_no: res.data.out_trade_no })
            .then((success) => {
              if (success.data.result == "success") {
               show.value = true
              }
            });
        },
      });
    });
}

//选择金额
function cutIndex(index) {
  //重置输入框
  if (index !== 0) {
    chargeValue.value = "";
  }
  indexCode.value = index;
}

//注入微信公众号权限验证配置
function setWxConfig() {
  request
    .getWxConfigInfo({ escaped_url: encodeURIComponent(window.location.href) })
    .then((res) => {
      data = res.data;
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: data.appId, // 必填，公众号的唯一标识
        timestamp: data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.nonceStr, // 必填，生成签名的随机串
        signature: data.signature, // 必填，签名
        jsApiList: ["chooseWXPay", "checkJsApi"], // 必填，需要使用的JS接口列表
      });
    });
}
</script>

<style  lang="scss" scoped>
.center{
 vertical-align: middle;
}
.t-f16-c0082ff{
  font-size: 16px;
  color: #0082ff;
}
.icon {
  width: 22px;
  height: 22px;
  vertical-align: middle;
}
.container {
  position: relative;
  background: #f6f6f6 !important;
}
.wechat-font {
  margin-left: 10px;
  font-size: 14px;
  color: #1a1a1a;
}
.wechat_c {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 22px;
  height: 22px;
}
.wechat {
  width: 20px;
  height: 20px;
  vertical-align: middle;
}
.pay-type {
  margin-top: 15px;
  position: relative;
}
.bg {
  width: 100%;
  height: 220px;
}
.grid-container {
  position: absolute;
  top: 140px;
  left: 10px;
  right: 10px;
}
.bg-v {
  background: #fff;
  border-radius: 5px;
  padding: 10px 15px;
}
.line {
  background: #efefef;
  height: 1px;
  margin: 15px 0px;
}
.grid-item-v {
  border-radius: 5px;
  line-height: 40px;
  height: 40px;
  border: 1px solid #1a1a1a;
  text-align: center;
  width: 100%;
}
.selected {
  background: #f19321;
  color: #fff;
  border: none;
}
.notive-view {
  position: absolute;
  top: 70px;
  left: 10px;
  right: 10px;
}
.input-sytle {
  font-size: 16px;
}
::v-deep.input-sytle[data-v-622f50c1] {
  font-size: 16px;
}

::v-deep.van-notice-bar {
  border-radius: 5px;
}
::v-deep.van-grid {
  padding-left: 0px !important;
}
::v-deep[class*="van-hairline"]::after {
  border: none;
}
::v-deep .van-grid-item__content {
  padding: 0 !important;
}
.padding {
  padding: 5px;
}
::v-deep.van-cell {
  border: none;
  background: none;
  font-weight: bold;
}
::v-deep.van-field__control {
  color: #fff;
  font-size: 16px;
}
::v-deep .van-popup {
  border-radius: 10px;
  left: 20px;
  right: 20px;
  transform: translateY(-50%);
}
.reject-view {
  text-align: center;
  align-content: center;
  padding: 20px;
  border-radius: 10px;
  align-items: center;
}
</style>